import { ThemeOptions } from '@material-ui/core';
import deepmerge from 'deepmerge';
import { defaultTheme, AlmeTheme, defaultDarkTheme } from '../../models/AlmeTheme';


const palette = {
    primary: {
        light: '#007AFF',
        main: '#0057BF',
        dark: '#0D3E86',
    },
    secondary: {
        light: '#00CE7C',
        main: '#09A761',
        dark: '#0D7F46',
    },
    background: {
        paper: '#e5e9f0',
        default: '#F5F5F7',
    },
};
const typography = {
    // This was added for the header (with the X and _ buttons) in iPhone 5
    // SE. It applies to other mobile devices in Portrait orientation. This
    // will affect other headings, so it may need to be moved in the future.
    h6: {
        [defaultTheme.breakpoints.down('xs')]: {
            fontSize: '16px',
        },
    },
    button:{
        textTransform: 'none',
    },
};

const overrides = {
    MuiDialog: {
        root: {
        },
    },
    MuiBackdrop: {
        root: {
            display: 'block',
            position: 'absolute',
        },
    },
    MuiContainer: {
        root: {
            'overscroll-behavior': 'contain',
        },
    },
};

const lightModeTheme = deepmerge(defaultTheme, {  palette, typography,overrides }) as ThemeOptions;

const darkPalette = {
        type: 'dark',
        primary: {
            light: '#007AFF',
            main: '#85CBFF',
            dark: '#E1F4FF',
        },
        secondary: {
            light: '#09A761',
            main: '#00CE7C',
            dark: '#82EB96',
        },
    };

   const  darkTypography= {
        // This was added for the header (with the X and _ buttons) in iPhone 5
        // SE. It applies to other mobile devices in Portrait orientation. This
        // will affect other headings, so it may need to be moved in the future.
        h6: {
            [defaultTheme.breakpoints.down('xs')]: {
                fontSize: '16px',
            },
        },
        button:{
            textTransform: 'none',
        },
    };

    const darkModeTheme = deepmerge(defaultDarkTheme,{palette:darkPalette,typography:darkTypography,overrides}) as ThemeOptions;

export const appThemeMain = {
    lightTheme: lightModeTheme,
    darkTheme: darkModeTheme,
} as AlmeTheme;